/**
 * Formats a number to fixed decimal places based on whether it has decimals
 * @param {number} value - The number to format
 * @param {number} decimals - Number of decimal places to use if value has decimals
 * @returns {number} Formatted number
 */
const formatNutritionValue = (value, decimals = 0) =>
    Number.isInteger(value) ? value : +value.toFixed(decimals);

/**
 * Calculates combined nutrition totals from base item nutrition and modifier totals
 * @param {Object} baseNutrition - Base nutrition object from the item
 * @param {Object} modifierTotals - Aggregated nutrition totals from modifiers
 * @returns {Object} Combined nutrition totals for all nutrition fields
 */
export const calculateNutritionTotals = (baseNutrition, modifierTotals) => {
    const base = baseNutrition || {};
    const modifiers = modifierTotals || {};

    const calories = (base.calories || 0) + (modifiers.calories || 0);
    const carbs = (base.carbs || 0) + (modifiers.carbs || 0);
    const fats = (base.fats || 0) + (modifiers.fats || 0);
    const protein = (base.protein || 0) + (modifiers.protein || 0);
    const salt = (base.salt || 0) + (modifiers.salt || 0);
    const fibre = (base.fibre || 0) + (modifiers.fibre || 0);
    const carbsSugars = (base.carbsSugars || 0) + (modifiers.carbsSugars || 0);
    const fatSaturates =
        (base.fatSaturates || 0) + (modifiers.fatSaturates || 0);

    return {
        calories: +calories.toFixed(0),
        carbs: formatNutritionValue(carbs),
        fats: formatNutritionValue(fats),
        protein: formatNutritionValue(protein),
        salt: formatNutritionValue(salt),
        fibre: formatNutritionValue(fibre),
        carbsSugars: formatNutritionValue(carbsSugars),
        fatSaturates: formatNutritionValue(fatSaturates)
    };
};
